import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import ModalManager from '../elements-modal/modal-manager';
import { connect } from 'react-redux';
import _ from 'lodash';
import AttendeeVisibilityFormContainer from '../app-main/components/reduxForms/forms/AttendeeVisibilityForm/AttendeeVisibilityFormContainer';

class VisibilityModal extends Component {
  constructor (props) {
    super(props);

    this.showVisibilityFormAnalytics = this.showVisibilityFormAnalytics.bind(this);
  }

  showVisibilityFormAnalytics () {
    const booking = _.get(this.props, 'booking.booking');
    const bookingId = _.get(booking, '_id');
    const wifiInstructions = _.get(booking, 'space.wifi_instructions');
    const gettingThere = _.get(booking, 'space.getting_there');

    const analyticsProps = {
      label: bookingId,
      wifi: !!wifiInstructions,
      getting_there: !!gettingThere
    };

    analyticsIntegrations.publicAttendee('attendee details: visibility settings', analyticsProps);
  }

  render () {
    return (
      <ModalManager {...this.props}>
        <BootstrapModal
          addCloseIcon
          ref="VisibilityModal"
          modalClass="VisibilityModal"
          body={(
            <div className="modal-content">
              <AttendeeVisibilityFormContainer
                submitCallback={() => this.props.toggleModal('')}
              />
            </div>
          )}
          allowClickAway={false}
          didMountFunction={this.showVisibilityFormAnalytics}
        />
      </ModalManager>
    );
  }
}

VisibilityModal.propTypes = {
  toggleModal: PropTypes.func
};

function mapStateToProps (state) {
  const { booking } = state;

  return {
    booking
  };
}

export default connect(mapStateToProps)(VisibilityModal);
